import { useAuthStore } from "@/state/pinia/auth";

/**
 * Adres panelu rozliczeń. Billing (plany, płatności, faktury, dane do faktury)
 * mieszka wyłącznie w SSO — jest wspólny dla całej rodziny LessTools, więc panel
 * sklepu tylko tam odsyła. `from=commerce` daje w SSO przycisk powrotu tutaj.
 */
export function billingUrl(tab = null) {
  const ssoUrl = process.env.VUE_APP_SSO_URL;

  if (!ssoUrl) return null;

  // Workspace, w którym właśnie siedzisz — żeby panel rozliczeń otworzył się
  // od razu na nim, zamiast na pierwszym z brzegu.
  const workspace = useAuthStore().getActiveWorkspace?.();

  // `tab` otwiera od razu właściwą zakładkę (np. "tokens").
  const params = new URLSearchParams({ from: "commerce" });

  if (tab) params.set("tab", tab);
  if (workspace) params.set("workspace", workspace);

  return `${ssoUrl.replace(/\/$/, "")}/billing?${params.toString()}`;
}
